import { TFunction } from 'i18next';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Container } from 'reactstrap';

import { FullSizeMessage } from '../../components/FullSizeMessage';
import { Content } from '../../components/layout/Content';

interface Props {
  t: TFunction;
}

const NotFoundComponent = ({ t }: Props) => (
  <Content>
    <Container className="min-vh-100">
      <FullSizeMessage description={t('notFound.description')} headline={t('notFound.heading')} iconKind="no_data" />
    </Container>
  </Content>
);

export const NotFound = withTranslation()(NotFoundComponent);
